import './Login.scss';
import { Button } from '@mui/material';
import { DATA_TEST_ID } from '../../constants/test';
import { Dispatch, SetStateAction, useCallback, useEffect } from 'react';
import { useAuthProvider } from '../../providers/AuthProvider';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logo.png';
import homeScreenLandscape from '../../assets/images/login/Landscape/Homescreen.jpg';
import homeScreenPortrait from '../../assets/images/login/Portrait/Homescreen.jpg';

interface Props {
    setActiveMenuIndex: Dispatch<SetStateAction<number>>;
}

const Login = ({setActiveMenuIndex}: Props) => {
    const authContext = useAuthProvider();
    const { t } = useTranslation();

    const imageSource = {
        landscape: homeScreenLandscape,
        portrait: homeScreenPortrait,
        msg: t('LoginPage.msg1')
      };

    const handleOnClickLogin = useCallback(() => {
        authContext.login();
    }, [authContext]);

    useEffect(() => {
        setActiveMenuIndex(-1);
        handleOnClickLogin();
        
    }, [handleOnClickLogin, setActiveMenuIndex]);

    return (
        <div className="c-login-page">
            <div className="c-image">
                <picture>
                    <source
                        media="(min-width:1101px)"
                        srcSet={`${imageSource.landscape}`}
                    />
                    <source
                        media="(max-width:1100px)"
                        srcSet={`${imageSource.portrait}`}
                    />
                    <img
                        alt={t('LoginPage.altBanner')}
                        data-testid={DATA_TEST_ID.Login.icon}
                        src={imageSource.landscape}
                    />
                </picture>
            </div>
            <div className="c-footer">
                <img 
                    alt={t('buttons.altLogo')} 
                    className="footer__app-logo"
                    data-testid={DATA_TEST_ID.Login.icon}
                    src={logo}
                />
                <div className="footer__app-name">
                    <h1>{t('appName')}</h1>
                </div>
                <Button 
                    className="footer__btn-login"
                    disableElevation 
                    disableRipple 
                    onClick={handleOnClickLogin}
                >   
                    {t('buttons.login')}
                </Button>
            </div>
        </div>
    );
};

export default Login;
